import React from 'react';
import LitStructuredText from './generic/LitStructuredText';
import { Link, graphql } from 'gatsby';
const ModularParagraphButton = ({ data }) => {
  const { buttonText, buttonPath, backgroundColor, paragraph } = data;
  return (
    <div className={`modular-paragraph-button-container ${backgroundColor}`}>
      <div className="modular-paragraph-button-inner modular-p modular-text-center">
        <LitStructuredText data={paragraph} basic />
        <Link to={buttonPath}>{buttonText}</Link>
      </div>
    </div>
  );
};

export default ModularParagraphButton;

export const fragment = graphql`
  fragment ModularParagraphButton on DatoCmsParagraphButton {
    internal {
      type
    }
    buttonText
    buttonPath
    backgroundColor
    paragraph {
      value
    }
  }
`;
